import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import Close from 'components/common/Close'
import SwitchTo from 'components/SwitchTo'
import SignTerms from 'components/SignTerms'
import formStyles from 'styles/form.module.scss'
import { checkLegalAge } from 'utils/validations'
import { trackButtonClick, trackNextSuccess } from 'tracking/homepage'
import {
  trackRegFormOpen,
  trackRegFormNext,
  trackRegFormSubmit,
} from 'analytics/ga'
import trackFbPixelLead from 'components/FbPixelVendorScriptLead'

export default class Wizard extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  }
  static Page = ({ children }) => children

  constructor(props) {
    super(props)
    this.state = {
      page: 0,
      values: props.initialValues || {},
    }
  }

  componentDidMount() {
    trackRegFormOpen()
  }

  next = values => {
    this.setState(
      state => ({
        page: Math.min(state.page + 1, this.props.children.length - 1),
        values,
      }),
      trackRegFormNext
    )
    trackButtonClick({
      fieldValue: `Next`,
    })
    trackNextSuccess()
  }

  previous = () =>
    this.setState(state => ({
      page: Math.max(state.page - 1, 0),
    }))

  /**
   * NOTE: Both validate and handleSubmit switching are implemented
   * here because 🏁 Redux Final Form does not accept changes to those
   * functions once the form has been defined.
   */

  validate = values => {
    const activePage = React.Children.toArray(this.props.children)[
      this.state.page
    ]

    if (checkLegalAge(values)) return checkLegalAge(values)

    return activePage.props.validate ? activePage.props.validate(values) : {}
  }

  handleSubmit = values => {
    const { children, onSubmit } = this.props
    const { page } = this.state
    const isLastPage = page === React.Children.count(children) - 1
    if (isLastPage) {
      onSubmit(values)
      trackRegFormSubmit()
      trackButtonClick({
        fieldValue: `Sign Up`,
      })
      trackFbPixelLead()
    } else {
      this.next(values)
    }
  }

  render() {
    const { children } = this.props
    const { page, values } = this.state
    const activePage = React.Children.toArray(children)[page]
    const isLastPage = page === React.Children.count(children) - 1

    return (
      <Form
        initialValues={values}
        validate={this.validate}
        onSubmit={this.handleSubmit}
      >
        {({ handleSubmit, submitting, values, pristine, invalid }) => {
          return (
            <form
              onSubmit={handleSubmit}
              className={formStyles.wrapper}
              noValidate=""
            >
              <Close />
              {activePage}
              {!isLastPage && (
                <div className={formStyles.formButton}>
                  <button
                    data-testid="next_button"
                    className="btn btn-primary btn-md btn-block"
                    type="submit"
                    disabled={false}
                  >
                    Next
                  </button>
                  <SwitchTo />
                </div>
              )}

              {isLastPage && (
                <div className={formStyles.formButton}>
                  <button
                    data-testid="sign_up_button"
                    className="btn btn-primary btn-md btn-block"
                    type="submit"
                    disabled={false}
                  >
                    Sign Up
                  </button>
                  <SignTerms />
                </div>
              )}
              {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
            </form>
          )
        }}
      </Form>
    )
  }
}
